<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "GlobalStyle"
};
</script>

<style>
#app {
  font-family: "SamsungSharpSans", "SamsungOneLatin", "SamsungOneCN",
    "SamsungOne", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
@font-face {
  font-family: "SamsungSharpSans";
  font-weight: 700;
  src: url("../../assets/font/SamsungSharpSans-Bold-export/SamsungSharpSans-Bold.eot");
  src: url("../../assets/font/SamsungSharpSans-Bold-export/SamsungSharpSans-Bold.woff2")
      format("woff2"),
    url("../../assets/font/SamsungSharpSans-Bold-export/SamsungSharpSans-Bold.woff")
      format("woff"),
    url("../../assets/font/SamsungSharpSans-Bold-export/SamsungSharpSans-Bold.ttf")
      format("opentype");
}
@font-face {
  font-family: "SamsungSharpSans";
  font-weight: 500;
  src: url("../../assets/font/SamsungSharpSans-Medium-export/SamsungSharpSans-Medium.eot");
  src: url("../../assets/font/SamsungSharpSans-Medium-export/SamsungSharpSans-Medium.woff2")
      format("woff2"),
    url("../../assets/font/SamsungSharpSans-Medium-export/SamsungSharpSans-Medium.woff")
      format("woff"),
    url("../../assets/font/SamsungSharpSans-Medium-export/SamsungSharpSans-Medium.ttf")
      format("opentype");
}
@font-face {
  font-family: "SamsungSharpSans";
  font-weight: 400;
  src: url("../../assets/font/SamsungSharpSans-Regular-export/SamsungSharpSans-Regular.eot");
  src: url("../../assets/font/SamsungSharpSans-Regular-export/SamsungSharpSans-Regular.woff2")
      format("woff2"),
    url("../../assets/font/SamsungSharpSans-Regular-export/SamsungSharpSans-Regular.woff")
      format("woff"),
    url("../../assets/font/SamsungSharpSans-Regular-export/SamsungSharpSans-Regular.ttf")
      format("opentype");
}
@font-face {
  font-family: "SamsungOne";
  font-weight: 600;
  src: url("../../assets/font/Korea/SamsungOneUI-600V3.0_0-export/SamsungOneUI-600V3.0_0.eot");
  src: url("../../assets/font/Korea/SamsungOneUI-600V3.0_0-export/SamsungOneUI-600V3.0_0.woff2")
      format("woff2"),
    url("../../assets/font/Korea/SamsungOneUI-600V3.0_0-export/SamsungOneUI-600V3.0_0.woff")
      format("woff"),
    url("../../assets/font/Korea/SamsungOneUI-600V3.0_0-export/SamsungOneUI-600V3.0_0.ttf")
      format("opentype");
}
@font-face {
  font-family: "SamsungOne";
  font-weight: 700;
  src: url("../../assets/font/Korea/SamsungOneUI-700V3.0-export/SamsungOneUI-700V3.0.eot");
  src: url("../../assets/font/Korea/SamsungOneUI-700V3.0-export/SamsungOneUI-700V3.0.woff2")
      format("woff2"),
    url("../../assets/font/Korea/SamsungOneUI-700V3.0-export/SamsungOneUI-700V3.0.woff")
      format("woff"),
    url("../../assets/font/Korea/SamsungOneUI-700V3.0-export/SamsungOneUI-700V3.0.ttf")
      format("opentype");
}
@font-face {
  font-family: "SamsungOneCN";
  font-weight: 400;
  src: url("../../assets/font/China/400/SamsungOneUISCN-400.eot");
  src: url("../../assets/font/China/400/SamsungOneUISCN-400.woff2")
      format("woff2"),
    url("../../assets/font/China/400/SamsungOneUISCN-400.woff") format("woff"),
    url("../../assets/font/China/400/SamsungOneUISCN-400.ttf")
      format("opentype");
}
@font-face {
  font-family: "SamsungOneCN";
  font-weight: 600;
  src: url("../../assets/font/China/600/SamsungOneUISCN-600.eot");
  src: url("../../assets/font/China/600/SamsungOneUISCN-600.woff2")
      format("woff2"),
    url("../../assets/font/China/600/SamsungOneUISCN-600.woff") format("woff"),
    url("../../assets/font/China/600/SamsungOneUISCN-600.ttf")
      format("opentype");
}
@font-face {
  font-family: "SamsungOneLatin";
  font-weight: 400;
  src: url("../../assets/font/Latin/400/SamsungOneUI-400.eot");
  src: url("../../assets/font/Latin/400/SamsungOneUI-400.woff2") format("woff2"),
    url("../../assets/font/Latin/400/SamsungOneUI-400.woff") format("woff"),
    url("../../assets/font/Latin/400/SamsungOneUI-400.ttf") format("opentype");
}
@font-face {
  font-family: "SamsungOneLatin";
  font-weight: 600;
  src: url("../../assets/font/Latin/600/SamsungOneUI-600.eot");
  src: url("../../assets/font/Latin/600/SamsungOneUI-600.woff2") format("woff2"),
    url("../../assets/font/Latin/600/SamsungOneUI-600.woff") format("woff"),
    url("../../assets/font/Latin/600/SamsungOneUI-600.ttf") format("opentype");
}
@font-face {
  font-family: "SamsungOneLatin";
  font-weight: 700;
  src: url("../../assets/font/Latin/700/SamsungOneUI-700.eot");
  src: url("../../assets/font/Latin/700/SamsungOneUI-700.woff2") format("woff2"),
    url("../../assets/font/Latin/700/SamsungOneUI-700.woff") format("woff"),
    url("../../assets/font/Latin/700/SamsungOneUI-700.ttf") format("opentype");
}
:root {
  font-size: 12px;
  font-family: "SamsungSharpSans", "SamsungOne", Helvetica, Arial, sans-serif;
  font-weight: 500;
}

@media (min-width: 360px) {
  :root {
    font-size: 12px;
    font-weight: 500;
  }
}
@media (min-width: 1024px) {
  :root {
    font-size: 14px;
  }
}
body {
  margin: 0;
  padding: 0;
  /* background-color: #ffffff; */
  color: #f5f5f5;
  background-color: black;
  font-family: "SamsungSharpSans", "SamsungOne", Helvetica, Arial, sans-serif;
  /* padding-bottom: env(safe-area-inset-bottom); */
  /* Allows content to fill the viewport and go beyond the bottom */
  width: 100%;
  height: 100%;

  /* Allows you to scroll below the viewport; default value is visible */
  overflow-y: scroll;

  /* To smooth any scrolling behavior */
  -webkit-overflow-scrolling: touch;
}
a {
  color: inherit;
  text-decoration: none;
}

.primary-text-color {
  color: #f5f5f5;
}
.secondary-text-color {
  color: #aaaaaa;
}
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
/* ::-webkit-scrollbar {

  /* height: 0 !important; */
/* width: 0; */
/* background-color: rgba(0, 0, 0, 0); */
/* } */

.route-button {
  border: 2px solid #aaaaaa;
  border-radius: 20px;
  width: 210px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  display: inline-block;
  text-decoration: none;
  text-align: center;
  /* line-height: 32px; */
  /* font-size: 0.67rem; */
  font-size: 10px;
  position: relative;
  cursor: pointer;
}
.route-button.left::before {
  content: " ";
  border-top: 2px solid #f5f5f5;
  border-left: 2px solid #f5f5f5;
  width: 5px;
  height: 5px;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%) rotate(-45deg);
}
.route-button.right::after {
  content: " ";
  border-top: 2px solid #f5f5f5;
  border-left: 2px solid #f5f5f5;
  width: 5px;
  height: 5px;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%) rotate(135deg);
}
@media (min-width: 1024px) {
  .route-button {
    width: auto;
    font-size: 1.9rem;
    font-weight: 500;
  }
  .route-button.right::after {
    content: " ";
    border-top: 4px solid #f5f5f5;
    border-left: 4px solid #f5f5f5;
    width: 10px;
    height: 10px;
    position: absolute;
    right: 34px;
    top: 50%;
    transform: translateY(-50%) rotate(135deg);
  }
  .route-button.left::before {
    content: " ";
    border-top: 4px solid #f5f5f5;
    border-left: 4px solid #f5f5f5;
    width: 10px;
    height: 10px;
    position: absolute;
    left: 30px;
    top: 50%;
    transform: translateY(-50%) rotate(-45deg);
  }
}
.txt-center {
  text-align: center;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.indicator-list {
  display: flex;
  justify-content: center;
  background-color: black;
  width: 78px;
  justify-content: space-evenly;
  /* padding: 6px 0px; */
  margin: auto;
  border-radius: 8px;
  /* height: 18px; */
  margin-top: 15px;
}
.indicator-list > .indicator-wrapper {
  width: 15px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 15px;
}
.indicator-list .indicator {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #aaaaaa;
}
.indicator-list .indicator.active {
  background-color: white;
}

select::-ms-expand {
  display: none;
}
@media (min-width: 1024px) {
  .desktop {
    display: none;
  }
}
</style>